import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { createHttpOptions } from '../utils/http-utils';

@Injectable({
  providedIn: 'root',
})
export class ApiKeyManagementService {
  protected http = inject(HttpClient);

  public generateApiKey() {
    return this.http.post(environment.api + 'User/generate-api-key', createHttpOptions());
  }

  public deleteApiKey() {
    return this.http.post(environment.api + 'User/delete-api-key', createHttpOptions());
  }
}
